import React, { Component } from 'react'
import PropTypes from 'prop-types'
import imagefallback from '@loyal_images/products/product_placeholder.png'

class Image extends Component {
  constructor () {
    super()
    this.state = {}
    this.fallback = () => {
      this.setState({ failed: true })
    }
  }

  render () {
    if (this.state.failed) {
      return <img src={imagefallback} alt={this.props.alt} className={this.props.className || ''} aria-hidden='true' />
    } else {
      return <img src={this.props.src} onLoad={imagefallback} onError={this.fallback} alt={this.props.alt} className={this.props.className || ''} aria-hidden='true' />
    }
  }
}

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string
}

export default Image



// WEBPACK FOOTER //
// ./src/features/Cart/Item/Image.js